function BlogSortMobile() {
	$( ".js-isotope-sort-control" ).on( "click", function () {
		$( ".js-isotope-sort-control" ).each( ( index, element ) => {
			element.classList.remove( "mixitup-control-active" );
		} );

		this.classList.add( "mixitup-control-active" );

		if ( $( ".js-isotope-sort-select" ).val() != this.dataset.value ) {
			$( ".js-isotope-sort-select" ).val( this.dataset.value ).trigger( "change" );
		}
	} );

	$( ".js-isotope-sort-select" ).on( "change", function () {
		$( ".js-isotope-sort-control" ).each( ( index, element ) => {
			element.classList.remove( "mixitup-control-active" );
		} );

		$( `.js-isotope-sort-control[data-value="${ this.value }"]` )
			.addClass( "mixitup-control-active" );
	} );
}

export { BlogSortMobile };